/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "../src/stylesheets";

// ViewComponent CSS (i.e. app/components/widget_component/widget_component.sass)
const componentStyles = require.context("../../components", true, /_component\.scss$/);
componentStyles.keys().forEach(componentStyles);

const componentJs = require.context("../../components", true, /_component\.js$/);
componentJs.keys().forEach(componentJs);

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActionCable from "@rails/actioncable";
import Toastr from "toastr/toastr";

import "../src/javascript/components/turbolinksPageLoader";
import "n2-styles/dist/js/n2-styles-turbolinks.min";
import "n2-styles/dist/js/vendors.min";

import "../src/javascript/components/n2Api";
import "../src/javascript/components/eventListeners";
import "../src/javascript/components/stringExtensions";
import "../src/javascript/components/toast";
import "../src/javascript/components/headerSearchBar";

import { Mercury, MercuryNotifications } from "mercury-client";

import ControllerLoader from "../src/javascript/components/ControllerLoader";

window.toastr = Toastr
window.ActionCable = ActionCable
require("jquery");

Rails.start();
Turbolinks.start();

N2.ready((e) => {
  Mercury.url = $('#action-cable').data('url')
  Mercury.registration = $('#action-cable').data('mercuryRegistration')
  MercuryNotifications.init()

  ControllerLoader.load(e);
})

N2.unload((e) => {
  MercuryNotifications.unload()
  ControllerLoader.unload(e)
});
